(function () {
    'use strict';
    angular.module('Services').factory('IssuedCreditNotesTable', IssuedCreditNotesTable);
    IssuedCreditNotesTable.$inject = [
        'TableLiteFactory',
        'AccountingService',
        'toastr',
        '$filter'
    ];

    function IssuedCreditNotesTable(
        TableLiteFactory,
        AccountingService,
        toastr, 
        $filter
    ) {
        return function(param = {}) {
            const tableData = {
                tableName: 'IssuedCreditNotesTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'ISSUE DATE',
                    viewName: 'issueDate',
                    filterName: 'issueDate',
                    width: '145px',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: '',
                        fromModel: '',
                        useArray: true,
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'REFERENCE', 
                    viewName: 'reference', 
                    filterName: 'reference', 
                    filter: {
                        type: 'text',
                        placeholder: 'Reference No.',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER', 
                    viewName: 'customer', 
                    filterName: 'customer',
                    filter: {
                        type: 'text', 
                        placeholder: 'Customer', 
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'SUBTOTAL', 
                    viewName: 'subTotal',
                    filterName: 'subTotal',
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'TAX AMOUNT', 
                    viewName: 'taxAmount', 
                    filterName: 'taxAmount', 
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'TOTAL AMOUNT', 
                    viewName: 'totalAmount', 
                    filterName: 'totalAmount', 
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'USED AMOUNT', 
                    viewName: 'usedAmount', 
                    filterName: 'usedAmount', 
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.IssuedCreditNotes.creditNotes,
                callbackFormat: ['success', 'error', 'filter'], 
                postRequestCallback: data => {
                    buildTableData(data);
                }, 
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err, "Error"); 
                }, 
                defaultFilters: angular.extend({
                    size: 20, 
                    page: 0, 
                    sort: 'issueDate,desc'
                }, param.filter || {})
            });

            function buildTableData(data){
                if(!data){
                    return tableData; 
                } 

                tableActions.initializeTableData(data); 
                angular.forEach(data.content, function(item){
                    item.issueDate = $filter('bbaDate')(item.issueDate, true);
                    item.customer = item.customer.name;
                    item.subTotal = $filter('bbaCurrency')(item.subTotalAmount, item.currency);
                    item.taxAmount = $filter('bbaCurrency')(item.taxAmount, item.currency);
                    item.totalAmount = $filter('bbaCurrency')(item.totalAmount, item.currency);
                    item.usedAmount = $filter('bbaCurrency')(item.usedAmount, item.currency);
                    tableData.data.push(item);
                });
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/IssuedCreditNotesTable.js